module.exports = __webpack_public_path__ + "static/media/Engineering Physics.32560ce5.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/OTH/Engineering Physics.pdf
// module id = 149
// module chunks = 0